import {capabilities} from "../capabilities";
import {ConditionalDocumentHandler} from "./document-handler";
import {InlineCollapsibles} from "./handlers/inline-collapsibles";
import {PlatformAwareKeybindings} from "./handlers/platform-aware-keybindings";
import {QuarkdownDocument} from "./quarkdown-document";
import {MathRenderer} from "./handlers/capabilities/math-renderer";
import {CodeHighlighter} from "./handlers/capabilities/code-highlighter";
import {MermaidRenderer} from "./handlers/capabilities/mermaid-renderer";
import {StyleHeadRelocator} from "./handlers/style-head-relocator";

/** Global document handlers that apply to all documents. */
export function getGlobalHandlers(document: QuarkdownDocument): ConditionalDocumentHandler[] {
    return [
        new StyleHeadRelocator(document),
        new InlineCollapsibles(document),
        new PlatformAwareKeybindings(document),
        capabilities.code && new CodeHighlighter(document),
        capabilities.math && new MathRenderer(document),
        capabilities.mermaid && new MermaidRenderer(document),
    ]
}
